import { createFileRoute, redirect } from "@tanstack/react-router"

// Port of app/watcher/page.tsx — index redirects to the default PIC lane
// (Huyền Trân) with no car selected.
export const Route = createFileRoute("/watcher/")({
  beforeLoad: () => {
    throw redirect({ href: "/watcher/a220daf2-b4cd-4b8c-9f8a-f277b965e4c4/_", replace: true })
  },
})
